import { IconButton } from "@libertify/ui";
import { useState } from "react";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";

export type VideoItemProps = {
  url: string;
};

export const VideoItem = ({ url }: VideoItemProps) => {
  const [thumb, setThumb] = useState(true);

  if (thumb)
    return (
      <Flex
        style={{ height: 500, width: 360 }}
        justify="center"
        align="center"
        vertical
      >
        <IconButton
          icon={<PlayCircleOutlined />}
          size="l"
          variant="utility"
          shape="round"
          onClick={() => setThumb(false)}
        />
      </Flex>
    );

  return (
    <video controls width={360} height={500} preload="none" autoPlay={true}>
      <track kind="captions" />
      <source src={url} type="video/mp4" />
    </video>
  );
};
